import { Inject, Injectable, InjectionToken } from '@angular/core';
import { AmplifyService } from 'aws-amplify-angular';
import { AuthService } from '../auth/auth.service';
import { HttpConfig, Path } from './http-config';

export const HTTP_CONFIG_TOKEN = new InjectionToken<HttpConfig>('HttpConfig');

@Injectable({
  providedIn: 'root'
})
export class HttpService {

  constructor(
    @Inject(HTTP_CONFIG_TOKEN) private config: HttpConfig,
    private as: AmplifyService,
    private authService: AuthService) {

    this.as.api().configure({
      endpoints: [{ name: config.apiName, endpoint: config.apiUrl + config.apiStage, region: config.region }]
    });
  }

  private async buildInit(path: Path, body: any, type: any = '') {
    let user = this.authService.getActualAuthState()?.user?.username? {'username': this.authService.getActualAuthState().user.username} : {};
    return {
      headers: {
        'X-Api-Key': this.config.apiKey,
        ...await this.getAuthorizationKey(path),
        ...user        
      },
      body: body,
      responseType: type
    }
  }

  private async getAuthorizationKey(path: Path) {
    let authorizationKey = null;
    if (path.needAuth) {
      const session = await this.authService.getCurrentSession();
      authorizationKey = session.getIdToken().getJwtToken();
    }
    return authorizationKey? {'Authorization' : authorizationKey} : {};
  }

  async post<T>(path: Path, body: any, type: any = ''): Promise<T> {
    return await this.as.api().post(path.apiName, path.getPath(), await this.buildInit(path, body, type)); 
  }

  async get<T>(path: Path, body: any, type: any = ''): Promise<T> {
    return await this.as.api().get(path.apiName, path.getPath(), await this.buildInit(path, body, type));
  }

  async put<T>(path: Path, body: any, type: any = ''): Promise<T> {
    return await this.as.api().put(path.apiName, path.getPath(), await this.buildInit(path, body, type));
  }

  async del<T>(path: Path, body: any, type: any = ''): Promise<T> {
    return await this.as.api().del(path.apiName, path.getPath(), await this.buildInit(path, body, type));
  }
}
